export const API = process.env.REACT_APP_BACKEND
export const FRONTAPP = process.env.REACT_APP_FRONTEND
export const IMAGESPATH = process.env.REACT_APP_IMAGESPATH